import infSign from "@kugou/interface-signature"
import { json2keyval } from './utils.js'
import $ from 'zepto-webpack'
import {Cookie} from '../lib/utils'
import UploadImage from "@kugou/upload-image"
// import Axios from "axios";
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

const APIURL = {
    //基础配置，选择框配置
    'baseConfig': 'https://h5activity.kugou.com/musician/config/singerBaseInfo',
    //发送短信
    'sendCode': 'https://loginservice.kugou.com/v8/send_mobile_code',
    //歌手搜索
    'singerSearch': 'https://h5activity.kugou.com/musician/v1/dj/singer_search',
    //认领歌手具体信息
    'singerInfo': 'https://h5activity.kugou.com/musician/v1/dj/singer_info',
    //提交入驻
    'submitSettle': 'https://h5activity.kugou.com/musician/v1/dj/settle',
    //编辑用户信息
    'editUser': 'https://genesisapi.kugou.com/v1/author_auth/save',
    //用户主页热度数据
    'musicianData': 'https://h5activity.kugou.com/v1/musician/singer_recent_data',
    //用户主页粉丝趋势数据
    'musicianFans': 'https://h5activity.kugou.com/musician/v1/datacenter/info',
    //用户主页作品管理数据
    'musicianWorkData': 'https://h5activity.kugou.com/v1/musician/singer_audio',
    //歌曲列表
    'songList': 'https://genesisapi.kugou.com/v1/content/my_list',
    //查看我的音乐人认证状态
    'starStatus': 'https://relationuser.kugou.com/v1/get_my_starstatus',
    //获取我的入住状态
    'myStatus': 'https://h5activity.kugou.com/musician/v1/dj/my_detail',
    //修改歌曲
    'updateSong': 'https://genesisapi.kugou.com/v1/content/update',
    //新建歌曲
    'createSong': 'https://genesisapi.kugou.com/v1/content/create',
    //修改用户信息
    'updateUser': 'https://genesisapi.kugou.com/v1/author_auth/save',
    //歌曲详情
    'songDetail': 'https://genesisapi.kugou.com/v1/content/my_detail',
    //播放链接
    'songURL': 'https://genesisapi.kugou.com/v1/content/get_file_download_info',
    //身份证检测
    'checkIdcard': 'https://h5activity.kugou.com/musician/v1/dj/check/idcard',
    //敏感词检测
    'sensitive': 'https://h5activity.kugou.com/musician/sensitive/word',
    //酷豆余额
    'beans': 'https://h5activity.kugou.com/musician/v1/user_bean',
    //获取粉丝数
    'getTotalFans': 'https://followservice.kugou.com/v1/getfansnum_wh'
}

export function api(option) {
    const notAddHeaderArr = ['sendCode', 'starStatus', 'getTotalFans']
    const notLoadingArr = ['singerSearch', 'checkIdcard', 'sensitive']
    notLoadingArr.indexOf(option.apiName) == -1 && window.eventEmitter.emit('loading', true)
    let getData = Object.assign({
        kugouid: window.kugouid || 0,
        userid: window.kugouid || 0,
        appid: window.appid,
        token: window.token,
        //clientver: window.version || 8900
    }, option.getData || {})
    let postData = option.postData || null
    return new Promise((resolve, reject) => {
        infSign(getData, postData, {
            useH5: true,
            postType: 'json',
            callback: (publicParams) => {
                const ajaxParams = {
                    type: option.methods || 'POST',
                    url: `${APIURL[option.apiName]}?${json2keyval(publicParams)}`,
                    data: postData ? JSON.stringify(postData) : null,
                    dataType: 'json',
                    contentType: 'application/json;charset=UTF-8',
                    success: (res, textStatus, request) => {
                        window.eventEmitter.emit('loading', false)
                        if (+res.status == 1 || (res.data && res.data.success)) {
                            resolve(res);
                        }else if(res.error_code == 20028){
                            console.log(request);
                            const eventid = request.getResponseHeader("SSA-CODE");
                            const mid = request.getResponseHeader("SSA-HMID") || window.mid;
                            console.log(eventid , mid);
                            window.jQuery = $;
                            if (eventid && mid) {
                                setTimeout(() => {
                                    window.KgUser.antiBrush({
                                    eventid: eventid||'',
                                    userid: window.kugouid,
                                    appid: window.appid,
                                    mid: mid||'',
                                    url: window.location.href,
                                    callback: (res)=> {
                                        if(res.status == 1) {
                                            // TODO 验证成功，继续业务操作
                                            //window.location.reload()
                                        } else {
                                            // TODO 验证失败，捕获相关的 error_code 进行相应的提示或操作
                                        }
                                    }
                                    })
                                }, 1000);
                            }
                        }else if(res.error_code == 20017){
                            window.eventEmitter.emit("toast", "为保障您账号安全，请重新登录");
                            try {
                                Cookie.remove("KuGoo", "/", "kugou.com");
                            } catch (error) {}
                                if(window.self == window.top){
                                window.location.href = 'https://musician.kugou.com';
                            }else{
                                window.top.location.href = 'https://musician.kugou.com';
                            }
                        } else {
                            reject(res);
                        }
                    },
                    error: err => {
                        window.eventEmitter.emit('loading', false)
                        reject(err);
                    }
                }
                //某些业务要加header头
                if(notAddHeaderArr.indexOf(option.apiName) == -1) {
                    ajaxParams.headers =  {
                        'KG-TID': 107
                    }
                }
                $.ajax(ajaxParams)
            }
        })
    })
}

export function uploadBase64Img(base64) {
    return new Promise((resolve, reject) => {
        let uploadEx = new UploadImage({
            size: 5,
            appid: 1014,
            inputEle: false,
            openLoading: ()=>{
                window.eventEmitter.emit('loading', true)
            },
            hideLoading: ()=>{
                window.eventEmitter.emit('loading', false)
            },
            fail: (err)=>{
                reject(err);
                window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
            }
        });
        uploadEx.uploadImg(base64, (res)=>{
            console.log('[ res123 ] >', res)
            if(+res.status == 1){
                resolve(res)
                console.log(res.url)
            }else{
                reject(res)
                console.log("uploadImg", res);
            }
        });
        /* $.ajax({
            type: 'POST',
            url: 'https://pc.service.kugou.com/node/node_song_report/uploadBase64',
            data: {
                data_url: base64
            },
            dataType: 'json',
            success: (response) => {
                console.log('response', response)
                if (+response.status == 1) {
                    resolve(response);
                } else {
                    reject(response);
                }
            },
            error: (err) => {
                reject(err);
                window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
            }
        }) */
    })
}

//写真-创建
//http://doc.kugou.net/showdoc-master/web/#/11?page_id=13473
export function uploadPhoto(url, photo_type) {
    window.eventEmitter.emit('loading', true)
    return new Promise((resolve, reject) => {
        let postParam = {
            portrait: url,
            img_type: photo_type,
            has_watermark: 2
        }
        infSign(
            {
                appid: window.appid,
                clientver: "1224",
                mid: window.mid,
                kugouid: window.kugouid,
                userid: window.kugouid,
                token: window.token,
            }, postParam, {
            useH5: true,
            callback: function (_get) {
                fetch(`https://h5activity.kugou.com/v1/musician/create_portrait?${json2keyval(_get)}`, {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(postParam)
                })
                .then(res => res.json())
                .then(data => {
                    window.eventEmitter.emit('loading', false)
                    if (+data.status == 1) {
                        resolve(data);
                    } else {
                        if(+data.errcode == 20017){
                            window.eventEmitter.emit("toast", "登录已过期，请刷新页面重新登录~");
                            try {
                                Cookie.remove("KuGoo", "/", "kugou.com");
                                setCookie('KuGoo','',-1)
                                console.log('remove cookie');
                            } catch (error) {
                                console.log(error);
                            }
                            
                            /* setTimeout(() => {
                                if(window.self == window.top){
                                    window.location.href = 'https://musician.kugou.com';
                                }else{
                                    window.top.location.href = 'https://musician.kugou.com';
                                }
                            }, 2000); */
                        }else{
                            window.eventEmitter.emit("toast", data.errmsg || "服务器错误");
                            reject(data);
                        }
                    }
                })
                .catch((e)=>{
                    window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
                    window.eventEmitter.emit('loading', false)
                    reject(err);
                })
            }
        })
    })
}
//写真-获取
//http://doc.kugou.net/showdoc-master/web/#/11?page_id=13475
export function getPhotoList(gdata){
    window.eventEmitter.emit('loading', true)
    return new Promise((resolve, reject) => {
        infSign(
            Object.assign({
                appid: window.appid,
                clientver: "1224",
                mid: window.mid,
                kugouid: window.kugouid,
                userid: window.kugouid,
                token: window.token
            }, gdata), null, {
            useH5: true,
            callback: function (_get) {
                fetch(`https://h5activity.kugou.com/v1/musician/portraits?${json2keyval(_get)}`, {
                    method: "get",
                })
                .then(res => res.json())
                .then(data => {
                    window.eventEmitter.emit('loading', false)
                    if (+data.status == 1) {
                        resolve(data);
                    }else {
                        if(+data.errcode == 20017){
                            window.eventEmitter.emit("toast", "登录已过期，请刷新页面重新登录~");
                            try {
                                Cookie.remove("KuGoo", "/", "kugou.com");
                                setCookie('KuGoo','',-1)
                                console.log('remove cookie');
                            } catch (error) {
                                console.log(error);
                            }
                            /* setTimeout(() => {
                                if(window.self == window.top){
                                    window.location.href = 'https://musician.kugou.com';
                                }else{
                                    window.top.location.href = 'https://musician.kugou.com';
                                }
                            }, 2000); */
                        }else{
                            window.eventEmitter.emit("toast", data.errmsg || "服务器错误");
                            reject(data);
                        }
                    }
                })
                .catch((e)=>{
                    window.eventEmitter.emit('loading', false)
                    window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
                    reject(err);
                })
            }
        })
    })
}
//删除写真
//http://doc.kugou.net/showdoc-master/web/#/11?page_id=13474
export function deletePhoto(pdata){
    window.eventEmitter.emit('loading', true)
    return new Promise((resolve, reject) => {
        infSign(
            {
                appid: window.appid,
                clientver: "1224",
                mid: window.mid,
                kugouid: window.kugouid,
                userid: window.kugouid,
                token: window.token,
            }, pdata, {
            useH5: true,
            callback: function (_get) {
                fetch(`https://h5activity.kugou.com/v1/musician/delete_portrait?${json2keyval(_get)}`, {
                    method: "POST",
                    mode: 'cors',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    body: JSON.stringify(pdata)
                })
                .then(res => res.json())
                .then(data => {
                    window.eventEmitter.emit('loading', false)
                    if (+data.status == 1) {
                        resolve(data);
                    } else {
                        if(+data.errcode == 20017){
                            window.eventEmitter.emit("toast", "登录已过期，请刷新页面重新登录~");
                            try {
                                Cookie.remove("KuGoo", "/", "kugou.com");
                                setCookie('KuGoo','',-1)
                                console.log('remove cookie');
                            } catch (error) {
                                console.log(error);
                            }
                            /* setTimeout(() => {
                                if(window.self == window.top){
                                    window.location.href = 'https://musician.kugou.com';
                                }else{
                                    window.top.location.href = 'https://musician.kugou.com';
                                }
                            }, 2000); */
                        }else{
                            window.eventEmitter.emit("toast", data.errmsg || "服务器错误");
                            reject(data);
                        }
                    }
                })
                .catch((e)=>{
                    window.eventEmitter.emit('loading', false)
                    window.eventEmitter.emit("toast", "网络错误，请稍后重试~");
                    reject(err);
                })
            }
        })
    })
}


// WEBPACK FOOTER //
// ./src/lib/api.js